@if (button().isLongAction) {
  <app-long-action-button
    [iconFunction]="button().icon"
    [disabled]="isDisabled()"
    [color]="button().color"
    [action$]="onLongActionClick()"
    [label]="button().label | translate"
    [appTooltip]="translatedTooltip()" />
} @else if (button().label) {
  <button
    motifButton
    [attr.aria-label]="button().label | translate"
    [color]="button().color"
    [disabled]="isDisabled()"
    [title]="button().label | translate"
    (click)="onActionClick()"
    [appTooltip]="translatedTooltip()">
    <motif-icon [iconFunction]="button().icon"></motif-icon>
    {{ button().label | translate }}
  </button>
} @else {
  <button
    motifButton
    [attr.aria-label]="button().label | translate"
    [color]="button().color"
    [disabled]="isDisabled()"
    [title]="button().label | translate"
    (click)="onActionClick()"
    [appTooltip]="translatedTooltip()">
    <motif-icon [iconFunction]="button().icon"></motif-icon>
  </button>
}
